module.exports = __webpack_public_path__ + "static/media/03-04.ac615fa3.png";